/**
 * AIOD (Discount & Gift) + UpCart integration fix.
 *
 * Problem: when an AIOD widget adds an item (e.g. the BXGY upsell "Add" button),
 * AIOD calls `window.aiodCartRefresh()`. Its implementation (free-gift-manager.js)
 * falls back to `window.location.reload()` whenever `AIOD_handleCartUpdate()`
 * returns falsy — which it does with UpCart — so the page reloads after every
 * upsell add.
 *
 * Fix: replace `window.aiodCartRefresh` with a version that refreshes the UpCart
 * drawer (`upcartRefreshCart`) and re-renders the AIOD side-cart widget
 * (`AIOD_UPDATE_SIDE_CART`) WITHOUT a full page reload. The item is already added
 * by AIOD before this runs, so no add logic is needed here. The original /cart
 * page reload behavior is preserved.
 *
 * AIOD assigns `aiodCartRefresh` during its async init, so we re-assert the
 * override for a short window in case AIOD overwrites it after we install it.
 */
export class NADAiodUpcartFix {
  static init(): void {
    const w = window as any;

    const softRefresh = async (cart: any = null): Promise<boolean> => {
      // Preserve AIOD's original behavior on the dedicated cart page.
      if (window.location.pathname.endsWith('/cart')) {
        window.location.reload();
        return false;
      }
      try {
        if (!cart) {
          cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) =>
            r.json()
          );
          w.aiod_latest_cart = cart;
        }
        try {
          await w.AIOD_handleCartUpdate?.(cart);
        } catch {
          /* ignore */
        }
        if (typeof w.upcartRefreshCart === 'function') {
          try {
            await w.upcartRefreshCart();
          } catch {
            /* ignore */
          }
        }
        document.dispatchEvent(new CustomEvent('AIOD_UPDATE_SIDE_CART'));
        setTimeout(() => document.dispatchEvent(new CustomEvent('AIOD_UPDATE_SIDE_CART')), 1500);
        return true;
      } catch {
        // Never fall back to a reload — a stale UI beats a full page reload here.
        return true;
      }
    };

    const install = (): void => {
      if (w.aiodCartRefresh !== softRefresh) {
        w.aiodCartRefresh = softRefresh;
      }
    };

    install();
    // Re-assert in case AIOD (re)assigns aiodCartRefresh during its async init.
    const interval = setInterval(install, 500);
    setTimeout(() => clearInterval(interval), 15000);
  }
}
